// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.map-info-window .segment {
    padding-bottom: 10px;
}

.marketplace-info-window {
    min-width: 280px;
}

.marketplace-info-window .job-summary .fa {
    float: right;
    font-size: 25px;
}

.marketplace-info-window .job-summary hr {
    margin-top: 5px;
    margin-bottom: 5px;
}

.marketplace-info-window .job-summary button {
    float: right;
}`, "",{"version":3,"sources":["webpack://./routes/app/routes/map/MapInfoWindow.css"],"names":[],"mappings":";AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\n.map-info-window .segment {\n    padding-bottom: 10px;\n}\n\n.marketplace-info-window {\n    min-width: 280px;\n}\n\n.marketplace-info-window .job-summary .fa {\n    float: right;\n    font-size: 25px;\n}\n\n.marketplace-info-window .job-summary hr {\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.marketplace-info-window .job-summary button {\n    float: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
